
import {PromotionStatus, PromotionType} from "@irati/types"
import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import promotionStatusQuery, {promotionStatusKey} from "./queries/promotionStatus"

class Promotions extends PBService {
  async getStatus(type: PromotionType, options: QueryOptions = {}): Promise<PromotionStatus> {
    const res = await client.query({...options, query: promotionStatusQuery, variables: {type}})
    return res.data[promotionStatusKey]
  }
}

const promotionsService = new Promotions({errorHandlers: []})

export default promotionsService
